import styled from "styled-components";
import Stack from "@vapor/react-material/Stack";

export const leftComponentMainDiv = {
  maxWidth: "360px",
  minWidth: "360px",
  position: "sticky",
  overflow: "auto",
  maxHeight: "70vh",
  overflowX: "hidden",
  overflowY: "hidden",
  paddingBottom: "50px",
};

export const mainComponentBgColor = {
  backgroundColor: "rgba(232,239,243,0.75)",
  boxShadow: "0px 0px 0px 16px rgba(232,239,243,0.75)",
};
export const MainComponentPageStyled = styled(Stack)`
  flex-direction: row;
  gap: 10px;
  margin-left: 16px;
  padding-left: 30px;
`;
